import React, { useState, useEffect } from 'react';
import PubSub from 'services/PubSub/';
import Modal from "components/Modal";
import { actionsType } from 'config/constants';
import Confirmation from 'components/ModalConfirmation/Confirmation';

let actions = [];

const initialSettings = {
    message: '',
    cancelBtnText: 'Cancelar',
    confirmBtnText: 'Vaciar',
    cancelCallback: () => { },
    confirmCallback: () => { }
};

const ModalConfirmation = () => {
    const [settings, setSettings] = useState(initialSettings);

    useEffect(() => {
        actions.push(PubSub.register(actionsType.MODAL.CONFIRMATION_OPEN, _open));

        return function cleanup() {
            actions.map(token => PubSub.unregister(token));
            actions = [];
        }
    }, []);

    const  _open = (payload) => {
        let sett = {...initialSettings};
        if (payload.value) {
            Object.assign(sett, payload.value)
        }

        setSettings(sett);
    }

    return (
        <Modal customClass={'modal-confirmation' + (settings.viewHeader ? ' view-header' : '')} actionOpen={actionsType.MODAL.CONFIRMATION_OPEN} actionClose={actionsType.MODAL.CONFIRMATION_CLOSE} callback={settings.cancelCallback}>
            <Confirmation settings={settings}  />
        </Modal>
    );
}

export default ModalConfirmation;
